import { CIRCLE_SHAPE } from '@loggi/ui/components/image/types';
import PropTypes from 'prop-types';
import React from 'react';
import AlertText from '../alert-text/alert-text.component';
import Alert from '../alert.component';
import styles from './user-feedback-alert.styles.scss';

export default function UserFeedbackAlert({
  illustration,
  title,
  description,
  buttonsProps
}) {
  return (
    <Alert
      illustration={illustration}
      illustrationClassName={styles.iconIllustration}
      illustrationShape={CIRCLE_SHAPE}
      buttonsProps={buttonsProps}
    >
      <AlertText title={title} description={description} />
    </Alert>
  );
}

UserFeedbackAlert.displayName = 'UserFeedbackAlert';

UserFeedbackAlert.propTypes = {
  illustration: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonsProps: PropTypes.arrayOf(PropTypes.object)
};

UserFeedbackAlert.defaultProps = {
  illustration: null,
  title: null,
  description: null,
  buttonsProps: null
};
